import { useState } from "react";
import FaiBox from "MuiComponents/FaiBox";
import FaiTypography from "MuiComponents/FaiTypography";
import theme from "assets/theme";
import { Form, Formik, FormikProps } from "formik";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import FormField from "components/FormField";
import FaiButton from "MuiComponents/FaiButton";
import FaiDropzone from "MuiComponents/FaiDropzone";
import FaiSelect from "MuiComponents/FaiSelect";
import Axios from "services/api/config";
import { setBusinessInfo } from "services/api/routes/Auth";
import PageHeader from "../components/PageHeader";

interface InitialObject {
	companyName: string;
	companyEmail: string;
	gstNumber: string;
	documents: string[];
	companyAddress: string;
	state: string;
	country: string;
	city: string;
	pinCode: string;
}
function BusinessDetails({ onNextStep = () => {} }) {
	const { palette } = theme;
	const [initialObject] = useState<InitialObject>({
		companyName: "",
		companyEmail: "",
		gstNumber: "",
		documents: [],
		companyAddress: "",
		state: "",
		city: "",
		country: "",
		pinCode: "",
	});
	const [isLoading, setLoading] = useState(false);

	const onSubmit = async (data: object) => {
		try {
			setLoading(true);
			const { data } = await Axios({
				...setBusinessInfo,
				data: {},
			});
			console.log("data", data);
			// You can trigger the next step here if necessary
			onNextStep();
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<FaiBox className="p-6 rounded-b-lg" bgColor={palette.white.main}>
				<FaiBox className={"business-details"}>
					<PageHeader
						title="Business Details"
						content="Please provide your business details to complete your profile and
							start selling on our platform."
					/>
					<Formik
						initialValues={initialObject}
						enableReinitialize={true}
						validateOnBlur={true}
						validateOnChange={true}
						onSubmit={onSubmit}
					>
						{(props: FormikProps<InitialObject>) => {
							const {
								// handleSubmit,
								// setFieldValue,
								handleChange,
								handleBlur,
								values,
								touched,
								// isValid,
								errors,
							} = props;
							return (
								<Form className="py-4">
									<Grid container spacing={2} mb={2}>
										<Grid item xs={12} sm={6}>
											<FaiBox xs={12} sm={6}>
												<FormField
													label={"Company Name"}
													name={"companyName"}
													placeholder={"Enter Company Name"}
													value={values.companyName}
													onChange={handleChange}
													onBlur={handleBlur}
													error={
														touched.companyName && Boolean(errors.companyName)
													}
													helperText={touched.companyName && errors.companyName}
													autoFocus
													isRequired
												/>
											</FaiBox>
										</Grid>
										<Grid item xs={12} sm={6}>
											<FaiBox xs={12} sm={6}>
												<FormField
													label={"Company E-mail"}
													name={"companyEmail"}
													placeholder={"Enter email"}
													value={values.companyEmail}
													onChange={handleChange}
													onBlur={handleBlur}
													error={
														touched.companyEmail && Boolean(errors.companyEmail)
													}
													helperText={
														touched.companyEmail && errors.companyEmail
													}
													isRequired
												/>
											</FaiBox>
										</Grid>
									</Grid>

									<Grid item sm={12} xs={12}>
										<FaiBox mb={1}>
											<FormField
												multiline
												rows={5}
												label={"Company address"}
												name={"companyAddress"}
												placeholder={"Enter Company Address"}
												isRequired
											/>
										</FaiBox>
									</Grid>

									<Grid container spacing={2}>
										<Grid item xs={12} sm={6}>
											<FaiBox mb={1} display="inline-block">
												<FaiTypography
													component="label"
													className="!text-base leading-6 !font-medium"
													variant="caption"
													textTransform="capitalize"
													isRequired
												>
													Country
												</FaiTypography>
											</FaiBox>
											<FaiSelect
												placeholder={"Country"}
												defaultValue={{ value: "clothing", label: "Clothing" }}
												name={"country"}
												options={[
													{ value: "clothing", label: "Clothing" },
													{ value: "electronics", label: "Electronics" },
													{ value: "furniture", label: "Furniture" },
													{ value: "others", label: "Others" },
													{ value: "real estate", label: "Real Estate" },
												]}
												isRequired
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox mb={1} display="inline-block">
												<FaiTypography
													component="label"
													variant="caption"
													className="!text-base leading-6 !font-medium"
													textTransform="capitalize"
													isRequired
												>
													State
												</FaiTypography>
											</FaiBox>
											<FaiSelect
												placeholder={"Choose State"}
												defaultValue={{ value: "clothing", label: "Clothing" }}
												name={"state"}
												options={[
													{ value: "clothing", label: "Clothing" },
													{ value: "electronics", label: "Electronics" },
													{ value: "furniture", label: "Furniture" },
													{ value: "others", label: "Others" },
													{ value: "real estate", label: "Real Estate" },
												]}
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox mb={1} display="inline-block">
												<FaiTypography
													component="label"
													variant="caption"
													className="!text-base leading-6 !font-medium"
													textTransform="capitalize"
													isRequired
												>
													City
												</FaiTypography>
											</FaiBox>
											<FaiSelect
												placeholder={"Country"}
												defaultValue={{ value: "clothing", label: "Clothing" }}
												name={"city"}
												options={[
													{ value: "clothing", label: "Clothing" },
													{ value: "electronics", label: "Electronics" },
													{ value: "furniture", label: "Furniture" },
													{ value: "others", label: "Others" },
													{ value: "real estate", label: "Real Estate" },
												]}
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox my={0.5}>
												<FormField
													label={"Postal Code"}
													name={"pinCode"}
													placeholder={"Enter Postal Code"}
													value={values.pinCode}
													onChange={handleChange}
													onBlur={handleBlur}
													error={touched.pinCode && Boolean(errors.pinCode)}
													helperText={touched.pinCode && errors.pinCode}
													isRequired
												/>
											</FaiBox>
										</Grid>

										<Grid item sm={12} xs={12}>
											<FaiBox mb={1}>
												<FaiBox
													mb={1}
													display="inline-block"
													className="w-full"
												>
													<FaiTypography
														component="label"
														variant="caption"
														className="!text-base leading-6 !font-medium"
														textTransform="capitalize"
														note="Notes"
														isRequired
													>
														Upload Document
													</FaiTypography>
												</FaiBox>
												<FaiDropzone
													options={{
														addRemoveLinks: true,
														uploadMultiple: false,
														maxFiles: 1,
													}}
												/>
												{/* <FaiTypography
													color="secondary"
													variant="caption"
													className="!mt-2"
												>
													Only support .jpg, .png and .svg and zip files
												</FaiTypography> */}
											</FaiBox>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox xs={12} sm={6}>
												<FormField
													label={"GST Number"}
													name={"gstNumber"}
													placeholder={"Enter GST no."}
													value={values.gstNumber}
													onChange={handleChange}
													onBlur={handleBlur}
													error={touched.gstNumber && Boolean(errors.gstNumber)}
													helperText={touched.gstNumber && errors.gstNumber}
													note="GST Number"
													isRequired
												/>
											</FaiBox>
										</Grid>
									</Grid>
								</Form>
							);
						}}
					</Formik>
				</FaiBox>
			</FaiBox>
			<FaiBox className="mt-5 p-6 rounded-lg" bgColor={palette.white.main}>
				<FaiBox className={"business-details"}>
					<PageHeader
						title="Logistic Details"
						content="Please fill in the logistics details to proceed with your order through our logistics partner. This information is essential for completing the process."
					/>
					<Formik
						initialValues={initialObject}
						enableReinitialize={true}
						validateOnBlur={true}
						validateOnChange={true}
						onSubmit={onSubmit}
					>
						{(props: FormikProps<InitialObject>) => {
							const {
								// handleSubmit,
								// setFieldValue,
								handleChange,
								handleBlur,
								values,
								touched,
								// isValid,
								errors,
							} = props;
							return (
								<Form className="">
									<Grid container spacing={2} mb={2}>
										<Grid item xs={12}>
											<FaiBox xs={12}>
												<Grid item xs={12} sx={{ px: 1 }}>
													<FormControlLabel
														className="text-left"
														control={
															<Checkbox
															// checked={isAgreed}
															// onChange={() => setIsAgreed(!isAgreed)}
															/>
														}
														label="Select this box if your warehouse and office address are the same."
														classes={{
															label: "!font-normal",
														}}
													/>
												</Grid>
											</FaiBox>
										</Grid>
										<Grid item sm={12} xs={12}>
											<FaiBox mb={1}>
												<FormField
													multiline
													rows={5}
													label={"Company Warehouse Address"}
													name={"companyWarehouseAddress"}
													placeholder={"Enter Address"}
													isRequired
												/>
											</FaiBox>
										</Grid>
									</Grid>

									<Grid container spacing={2}>
										<Grid item xs={12} sm={6}>
											<FaiBox mb={1} display="inline-block">
												<FaiTypography
													component="label"
													className="!text-base leading-6 !font-medium"
													variant="caption"
													textTransform="capitalize"
													isRequired
												>
													Country
												</FaiTypography>
											</FaiBox>
											<FaiSelect
												placeholder={"Country"}
												defaultValue={{ value: "clothing", label: "Clothing" }}
												name={"country"}
												options={[
													{ value: "clothing", label: "Clothing" },
													{ value: "electronics", label: "Electronics" },
													{ value: "furniture", label: "Furniture" },
													{ value: "others", label: "Others" },
													{ value: "real estate", label: "Real Estate" },
												]}
												isRequired
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox mb={1} display="inline-block">
												<FaiTypography
													component="label"
													variant="caption"
													className="!text-base leading-6 !font-medium"
													textTransform="capitalize"
													isRequired
												>
													State
												</FaiTypography>
											</FaiBox>
											<FaiSelect
												placeholder={"Choose State"}
												defaultValue={{ value: "clothing", label: "Clothing" }}
												name={"state"}
												options={[
													{ value: "clothing", label: "Clothing" },
													{ value: "electronics", label: "Electronics" },
													{ value: "furniture", label: "Furniture" },
													{ value: "others", label: "Others" },
													{ value: "real estate", label: "Real Estate" },
												]}
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox mb={1} display="inline-block">
												<FaiTypography
													component="label"
													variant="caption"
													className="!text-base leading-6 !font-medium"
													textTransform="capitalize"
													isRequired
												>
													City
												</FaiTypography>
											</FaiBox>
											<FaiSelect
												placeholder={"Country"}
												defaultValue={{ value: "clothing", label: "Clothing" }}
												name={"city"}
												options={[
													{ value: "clothing", label: "Clothing" },
													{ value: "electronics", label: "Electronics" },
													{ value: "furniture", label: "Furniture" },
													{ value: "others", label: "Others" },
													{ value: "real estate", label: "Real Estate" },
												]}
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox my={0.5}>
												<FormField
													label={"Postal Code"}
													name={"pinCode"}
													placeholder={"Enter Postal Code"}
													value={values.pinCode}
													onChange={handleChange}
													onBlur={handleBlur}
													error={touched.pinCode && Boolean(errors.pinCode)}
													helperText={touched.pinCode && errors.pinCode}
													isRequired
												/>
											</FaiBox>
										</Grid>
									</Grid>

									<FaiBox className="mt-6">
										<Grid container className="flex gap-5">
											<FaiButton
												color="primary"
												variant={"contained"}
												disabled={isLoading}
											>
												Save
											</FaiButton>
											<FaiButton variant={"outlined"} onClick={onNextStep}>
												Change Office Details
											</FaiButton>
										</Grid>
									</FaiBox>
								</Form>
							);
						}}
					</Formik>
				</FaiBox>
			</FaiBox>
		</>
	);
}
export default BusinessDetails;
